import React, { useEffect, useMemo, useState } from 'react';
import {
  Card, Form, Row, Col, Button, Table,
} from 'react-bootstrap';
import { PlusLg } from 'react-bootstrap-icons';

import _ from 'lodash';
import GrantSourcesToggle from '../Partials/GrantSourcesToggle';
import api from '../../../api';

export default function Budget({
  data, start, end, periods, onChange, finSources, disabled
}) {
  // #region Modify items
  const addCard = () => {
    const lastId = data
      .filter((d) => d.id <= 0)
      .map((d) => d.id)
      .sort((a, b) => a - b)
      [0];
    const newId = lastId === undefined ? 0 : lastId - 1;
    onChange(data.concat([{
      id: newId, type: finSources?.map((f) => f.type)[0] ?? 'fb', year: undefined, agreementId: undefined, bcCodeId: undefined, fundingId: undefined, sum: undefined,
    }]), 'plans');
  };

  const deleteCard = (itemId) => {
    onChange(data.filter((d) => d.id !== itemId), 'plans');
  };

  const onPlanItemChange = (newPlan, field) => {
    const dataCopy = [...data];
    const changedItem = dataCopy.find((d) => d.id === newPlan.id);
    changedItem[field] = newPlan[field];

    // 08.12.2022: все ограничения решили снять
    // //дополнительная подстановка значений полей для синхронизации типов (со-)финансирования в рамках года
    // //если меняется план по гранту
    // if (changedItem.type === 'fb') {
    //   let sameYearSfs = dataCopy.filter(d => d.year === changedItem.year);
    //   sameYearSfs.forEach(s => {
    //     if (s.fundingId !== changedItem.fundingId) s.fundingId = changedItem.fundingId;
    //   })
    // }
    // //если меняется год у плана по софинансированию
    // if (changedItem.type === 'sf' && field === 'year') {
    //   const availableFunding = restrictFinSource('fb', 'sf', changedItem.year, 'funding');
    //   if (availableFunding.length === 1) changedItem.fundingId = availableFunding[0].id;
    // }

    onChange(dataCopy, 'plans');
  };
  // #endregion

  const rangeIncludes = (y, start, end) => (!start || start <= y) && (!end || end >= y);

  const years = useMemo(
    () => periods.filter((p) => !p.isClosed && rangeIncludes(p.year, start, end)).map((p) => p.year),
    [periods, start, end],
  );

  // const restrictFinSource = (parentType, childType, year, source) => {
  //   if (data && finSources && parentType && source) {
  //     const availableValues = year
  //         ? data.filter(p => p.type === parentType && p.year === year && p[source + 'Id']).map(p => p[source + 'Id'])
  //         : [];
  //     return finSources.find(s => s.type === childType)?.sources[source].filter(s => availableValues.length === 0 || availableValues.includes(s.id)) || [];
  //   } else return [];
  // };

  return (
    <Card className="mb-4">
      <Card.Header as={Card.Title} className="p-4">Бюджет</Card.Header>
      <Card.Body className="p-4">
        {data.map((item, index) => {
          const isItemEnabled = !item.year || years.includes(item.year);

          return (
            <Row key={index}>
              <Form.Group as={Col}>
                <Card className="mb-4">
                  <Card.Header style={cardHeaderStyling}>
                    {isItemEnabled && data.length > 1 && <Button onClick={() => deleteCard(item.id)} variant="light" className="btn-close" size="sm" />}
                  </Card.Header>
                  <Card.Body>
                    <GrantSourcesToggle
                      plan={item}
                      finSources={_.keyBy(finSources, 'type')}
                      onChange={(newPlan, field) => onPlanItemChange(newPlan, field)}
                      readOnly={!isItemEnabled || disabled}
                      years={isItemEnabled ? years : [item.year]}
                    />
                  </Card.Body>
                </Card>
              </Form.Group>
            </Row>
          );
        })}
        <Row>
          <Form.Group as={Col} md="12">
            <Button onClick={addCard} disabled={disabled} variant="outline-primary">
              <PlusLg className="me-1 mb-1" />
              Добавить
            </Button>
          </Form.Group>
        </Row>
      </Card.Body>
    </Card>
  );
}

const cardHeaderStyling = {
  display: 'flex', justifyContent: 'end', minHeight: 38,
};
